import React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const user = {
  name: "Robert Downey",
  avatar: "",
  city: "New York",
  country: "USA",
  jobTitle: "Senior Developer",
  timezone: "GMT-7",
};

export const Profile = (props) => {
  return (
    <Card {...props}>
      <CardContent>
        <Box
          sx={{
            height: 290,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Avatar src={user.avatar} sx={{ height: 64, mb: 2, width: 64 }} />
          <Typography color='textPrimary' gutterBottom variant='h5'>
            {user.name}
          </Typography>
          <Typography color='textSecondary' variant='body2'>
            {`${user.city} ${user.country}`}
          </Typography>
          <Typography color='textSecondary' variant='body2'>
            {user.timezone}
          </Typography>
        </Box>
      </CardContent>
      <Divider />
      <CardActions>
        <Button color='primary' fullWidth variant='text'>
          Upload Picture
        </Button>
      </CardActions>
    </Card>
  );
};
